'use client'
import Link from 'next/link'

import { PaperClipIcon } from '@heroicons/react/20/solid'
import { getApplyRedirectUrl } from '@/lib/utils/functions'
import { useAuth } from '@/lib/utils/providers/supabase/supabase-auth-provider'

const London = [
  // {
  //   role: 'Programme Director',
  //   description: 'Leadership Position',
  //   type: 'Full Time',
  //   equity: '3.5% to 6%',
  //   experience: '4-6 Years',
  //   salaryRange: '£60,000 to £90,000',
  //   outline:
  //     'One of the four key hires for each city AI Forge. A requirement to be in the Forge 108 days a year and very healthy budget to ensure delivery of a world class programme.',
  //   fullDescription: {
  //     filename: 'Program_Director.pdf',
  //     url: 'https://aiforge.s3.eu-west-2.amazonaws.com/Programme_Director.pdf',
  //   },
  // },
  // {
  //   role: 'Dealflow Director',
  //   description: 'Leadership Position',
  //   type: 'Full Time',
  //   equity: '3.5% to 6%',
  //   experience: '4-6 Years',
  //   salaryRange: '£60,000 to £90,000',
  //   outline:
  //     'One of the four key hires for each city AI Forge. Very flexible working with an anticipated requirement to be in the Forge c10 days per Cohort.',
  //   fullDescription: {
  //     filename: 'Dealflow_Director.pdf',
  //     url: 'https://aiforge.s3.eu-west-2.amazonaws.com/Dealflow_Director.pdf',
  //   },
  // },
  // {
  //   role: 'Investment Director',
  //   description: 'Leadership Position',
  //   type: 'Full Time',
  //   equity: '4%',
  //   experience: '4-6 Years',
  //   salaryRange: '£60,000 to £90,000',
  //   outline:
  //     'One of the four key hires for each city AI Forge.  Very flexible working with an anticipated requirement to be in the Forge c25 days per Cohort',
  //   fullDescription: {
  //     filename: 'Investment_Director.pdf',
  //     url: '',
  //   },
  // },
  // {
  //   role: 'London: Investment Analyst',
  //   description: 'Varied and Engaging Position',
  //   type: 'Full Time',
  //   equity: '1%',
  //   experience: '2-4 Years',
  //   salaryRange: '£50,000',
  //   outline:
  //     'This is an engaging and diverse role. The position offers great flexibility in terms of location, with an expectation to be present at the London Forge twice a week, conveniently situated near Moorgate and Liverpool St.',
  //   fullDescription: {
  //     filename: 'Investment_Analyst_London.pdf',
  //     url: 'https://aiforge.s3.eu-west-2.amazonaws.com/Investment+Analyst+Job+Description+CM+Amends-3.pdf',
  //   },
  // },
  // {
  //   role: 'Partnership Director',
  //   description: 'Leadership Position',
  //   type: 'Full Time',
  //   equity: '3.5% to 6%',
  //   experience: '4-6 Years',
  //   salaryRange: '£60,000 to £90,000',
  //   outline:
  //     'One of the four key hires for each city AI Forge. Very flexible working with an anticipated requirement to be in the Forge c40 days per Cohort.',
  //   fullDescription: {
  //     filename: 'Partnership_Director.pdf',
  //     url: 'https://aiforge.s3.eu-west-2.amazonaws.com/Partnership_Director.pdf',
  //   },
  // },
  // {
  //   role: 'Head of Design',
  //   description: '',
  //   type: 'Full Time',
  //   equity: '2.5% to 4%',
  //   experience: '2-4 Years',
  //   salaryRange: '£50,000 to £60,000',
  //   outline:
  //     'This is a fast-paced and dynamic role having to satisfy 10 x ‘demanding clients simultaneously’ three times a year. The role requires the skills to identify the needs of each start up and together with your assistant, schedule time with them to plan their full design requirements and then implement them in a ‘super-fast’ timeline. The role demands working in the Forge 30 x days in every Cohort.',
  //   fullDescription: {
  //     filename: 'Head_of_Design.pdf',
  //     url: 'https://aiforge.s3.eu-west-2.amazonaws.com/Head_of_Design.pdf',
  //   },
  // },
]

export function Jobs() {
  const { session } = useAuth()
  return (
    <div className="bg-gradient-to-r from-[#060606] to-black py-10 px-1">
      {/* <div className="max-w-7xl mx-auto">
        <div className=" pb-5 pt-20">
          <div className="-ml-2 -mt-2 flex flex-wrap items-baseline">
            <h3 className="ml-2 mt-2 text-base font-semibold leading-6 text-gray-100">
              Job Postings
            </h3>
            <p className="ml-2 mt-1 truncate text-xl text-blue-500">
              AI Forge London
            </p>
          </div>
        </div>
        {London.map((job) => (
          <div
            className="overflow-hidden bg-gray-900 shadow sm:rounded-lg xs:w-full lg:w-1/2 my-4"
            key={job.role}
          >
            <div className="flex items-center justify-between px-4 py-5 sm:px-6">
              <div className="mr-4">
                <h3 className="text-base font-semibold leading-6 text-gray-100">
                  {job.role}
                </h3>
                <p className="mt-1 max-w-2xl text-sm text-gray-500">
                  {job.description}
                </p>
              </div>
              <Link href="/jobs/form">
                <button className="px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600 hover:duration-300">
                  Apply Now
                </button>
              </Link>
            </div>
            <div className="border-t border-gray-700 px-4 py-5 sm:px-6">
              <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">Type</dt>
                  <dd className="mt-1 text-sm text-gray-100">{job.type}</dd>
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">Equity</dt>
                  <dd className="mt-1 text-sm text-gray-100">{job.equity}</dd>
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">
                    Experience
                  </dt>
                  <dd className="mt-1 text-sm text-gray-100">
                    {job.experience}
                  </dd>
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">
                    Salary Range
                  </dt>
                  <dd className="mt-1 text-sm text-gray-100">
                    {job.salaryRange}
                  </dd>
                </div>
                <div className="sm:col-span-2">
                  <dt className="text-sm font-medium text-gray-500">Outline</dt>
                  <dd className="mt-1 text-sm text-gray-100">{job.outline}</dd>
                </div>
                <div className="sm:col-span-2">
                  <dt className="text-sm font-medium text-gray-500">
                    Full Description
                  </dt>
                  <dd className="mt-1 text-sm text-gray-100">
                    <ul
                      role="list"
                      className="divide-y divide-gray-200 rounded-md border border-gray-700"
                    >
                      <li className="flex items-center justify-between py-3 pl-3 pr-4 text-sm">
                        <div className="flex w-0 flex-1 items-center">
                          <PaperClipIcon
                            className="h-5 w-5 flex-shrink-0 text-gray-400"
                            aria-hidden="true"
                          />
                          <span className="ml-2 w-0 flex-1 truncate">
                            {job.fullDescription.filename}
                          </span>
                        </div>
                        <div className="ml-4 flex-shrink-0">
                          <a
                            href={job.fullDescription.url}
                            className="font-medium text-blue-600 hover:text-blue-500 hover:duration-500"
                          >
                            Download
                          </a>
                        </div>
                      </li>
                    </ul>
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        ))}
      </div> */}
      <div className="max-w-7xl mx-auto">
        <div className=" pb-5 pt-20">
          <div className="-ml-2 -mt-2 flex flex-wrap items-baseline">
            <h3 className="ml-2 mt-2 text-base font-semibold leading-6 text-gray-100">
              Job Postings
            </h3>
            <p className="ml-2 mt-1 truncate text-xl text-blue-500">
              AI Forge London
            </p>
          </div>
        </div>
        {/* <h3 className='text-blue-300 pb-32'> We completed our city teams! <br/> Stay tuned for future city expansion postings.</h3> */}
        {London.map((job) => (
          <div
            className="overflow-hidden bg-gray-900 shadow sm:rounded-lg xs:w-full lg:w-1/2 my-4"
            key={job.role}
          >
            <div className="flex items-center justify-between px-4 py-5 sm:px-6">
              <div className="mr-4">
                <h3 className="text-base font-semibold leading-6 text-gray-100">
                  {job.role}
                </h3>
                <p className="mt-1 max-w-2xl text-sm text-gray-500">
                  {job.description}
                </p>
              </div>
              <Link href={`${getApplyRedirectUrl(session)}`}>
                <button className="px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600 hover:duration-300">
                  Apply Now
                </button>
              </Link>
            </div>
            <div className="border-t border-gray-700 px-4 py-5 sm:px-6">
              <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">Type</dt>
                  <dd className="mt-1 text-sm text-gray-100">{job.type}</dd>
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">Equity</dt>
                  <dd className="mt-1 text-sm text-gray-100">{job.equity}</dd>
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">
                    Experience
                  </dt>
                  <dd className="mt-1 text-sm text-gray-100">
                    {job.experience}
                  </dd>
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-500">
                    Salary Range
                  </dt>
                  <dd className="mt-1 text-sm text-gray-100">
                    {job.salaryRange}
                  </dd>
                </div>
                <div className="sm:col-span-2">
                  <dt className="text-sm font-medium text-gray-500">Outline</dt>
                  <dd className="mt-1 text-sm text-gray-100">{job.outline}</dd>
                </div>
                <div className="sm:col-span-2">
                  <dt className="text-sm font-medium text-gray-500">
                    Full Description
                  </dt>
                  <dd className="mt-1 text-sm text-gray-100">
                    <ul
                      role="list"
                      className="divide-y divide-gray-200 rounded-md border border-gray-700"
                    >
                      <li className="flex items-center justify-between py-3 pl-3 pr-4 text-sm">
                        <div className="flex w-0 flex-1 items-center">
                          <PaperClipIcon
                            className="h-5 w-5 flex-shrink-0 text-gray-400"
                            aria-hidden="true"
                          />
                          <span className="ml-2 w-0 flex-1 truncate">
                            {job.fullDescription.filename}
                          </span>
                        </div>
                        <div className="ml-4 flex-shrink-0">
                          <a
                            href={job.fullDescription.url}
                            className="font-medium text-blue-600 hover:text-blue-500 hover:duration-500"
                          >
                            Download
                          </a>
                        </div>
                      </li>
                    </ul>
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
